import { useContext, useEffect, useMemo } from 'react';
import { matchRoutes, useNavigate } from 'react-router-dom';
import { routers } from './routes';
import { useMemoizedFn } from 'ahooks';
import { AuthContext } from '@/auth/AuthContext';
import { INDEX_PATH } from '@/config';

const AuthRoute = ({ children }: any) => {
	const navigate = useNavigate();
	const { isAuth, signOut } = useContext(AuthContext);
	const mathchs = matchRoutes(routers, location);

	const isExist = useMemo(() => mathchs?.some(item => item.pathname == location.pathname), [mathchs]);
	const logout = useMemoizedFn(() => signOut());

	useEffect(() => {
		// if (!isAuth()) {
		//     ElMessageBox.alert('会话超时，请重新登录', '温馨提示', { type: 'warning', showClose: false }).then(() => {
		//         logout();
		//         navigate('/login');
		//     });
		// }
		// 这里判断条件是：token 存在并且是匹配到路由并且是已经登录的状态
		if (isExist) {
			// 如果你已经登录了，但是你通过浏览器里直接访问login的话不允许直接跳转到login路由，必须通过logout来控制退出登录或者是token过期返回登录界面
			if (location.pathname == '/' || location.pathname == '/login') {
				navigate(INDEX_PATH);
			} else {
				// 如果是其他路由就跳到其他的路由
				navigate(location.pathname);
			}
		}
	}, [isAuth, isExist, logout, navigate]);

	return children;
};

export default AuthRoute;
